import { Component, Fragment } from 'react'
import filter from 'lodash/filter'
import Select from 'react-select'
import store from 'store2'
import { FormattedMessage, injectIntl, intlShape, defineMessages } from 'react-intl'
import Typeahead from '../helpers/Typeahead'
import TravelDatepicker from '../helpers/TravelDatepicker'
import GuestPicker from '../forms/GuestPicker'

import './hero-search.sass'
import { autosuggestStyles } from '../search/FiltersLa'
import { generateMonthPicker } from '../../utils'
import moment from 'moment'
import PreviousSearchHandler from './PreviousSearchHandler'

const msg = defineMessages({
  destination: {
    id: 'destination',
    defaultMessage: 'Destination',
  },
})

const monthes = generateMonthPicker()
const PreviousItems = new PreviousSearchHandler()
class HeroSearch extends Component {
  constructor(props) {
    super(props)
    const date = store('date')
    const departureMonth = store('departure_date')
    const roomParams = store('roomParams')
    this.state = {
      dateFrom: date ? date[0] : null,
      dateTo: date ? date[1] : null,
      departureMonth: departureMonth || undefined,
      roomParams: roomParams,
      kind: 20,
      url: '',
      title: '',
      modelType: '',
      dateStorage: date ? true : false,
      departureMonthStorage: departureMonth ? true : false,
      roomParamsStorage: roomParams ? true : false,
    }
    this.previousSearchResults = []
    this.selectRef = React.createRef()
  }

  componentDidMount() {
    PreviousItems.getResults().then(results => {
      this.previousSearchResults = results
    })
  }

  hadleToggleButtonClick = (kind) => {
    this.setState({
      kind: +kind,
    })
  }

  handleDestinationChange = (val) => {
    this.setState({
      url: val.url || this.props.searchLaUrl,
      kind: val.item.kind,
      title: val.item.itemTitle || val.item.title,
      modelType: val.item.modelType,
      searchKind: val.item.searchKind,
    }, this.handleInputChange)
  }

  handleDatesChange = (val) => {
    let month

    if (val.dateFrom && val.dateTo) {
      let date = moment(val.dateFrom).startOf('month').format('YYYY-MM-DD')
      month = filter(monthes, { from: date })
      store('date', [val.dateFrom, val.dateTo])

      if (month) {
        store('departure_date', month[0])
      }
    }
    if (val.dateFrom !== this.state.dateFrom || val.dateTo !== this.state.dateTo) {
      this.setState({
        dateFrom: val.dateFrom,
        dateTo: val.dateTo,
        departureMonth: month ? month[0] : undefined,
        dateStorage: false
      }, this.handleInputChange)
    }
  }

  handleMonthChange = (val) => {
    let dateTo, dateFrom
    if (val) {
      dateFrom = val.from
      dateTo = moment(val.from).add(7, 'days').format('YYYY-MM-DD')
      store('departure_date', val)
      store('date', [dateFrom, dateTo])
    }

    this.setState({
      dateFrom,
      dateTo,
      departureMonth: val,
      departureMonthStorage: false,
    }, this.handleInputChange)
  }

  handleGuestsChange = (roomParams) => {
    this.setState({
      roomParams,
      roomParamsStorage: false,
    }, this.handleInputChange)
  }

  handleInputChange() {
    setTimeout(() => {
      const { 
        url, dateFrom, departureMonth, roomParams, 
        kind, departureMonthStorage, dateStorage, roomParamsStorage 
      } = this.state
      if (!url) {
        document.querySelector('.hero-search .react-autosuggest__input').focus()
      } else if (kind === 10 && !departureMonth || kind === 10 && departureMonth && departureMonthStorage) {
        this.selectRef.current.focus()
      } else if (kind === 20 && !dateFrom || kind === 20 && dateFrom && dateStorage) {
        document.getElementById('datepicker').click()
      } else if (!kind && !dateFrom || !kind && dateFrom && dateStorage) {
        document.getElementById('datepicker').click()
      } else if (!roomParams || roomParams && roomParamsStorage) {
        document.querySelector('.rooms-and-guest-selector').click()
      }
    }, 150)
  }

  handleSubmit = () => {
    if (!this.state.loading) {
      this.setState({
        loading: true,
      }, () => {
        PreviousItems.setResults(this.state)
        window.location.href = this.state.url || this.props.searchLaUrl
      })
    }
  }

  render() {
    const { dateFrom, dateTo, kind, departureMonth, loading } = this.state
    const { intl } = this.props
    return (
      <div className={`hero-search ${loading ? 'placeholder-animation' : ''}`}>
        <div className='hero-search__field'>
          <Typeahead withIcon placeholder={intl.formatMessage(msg.destination)} selectCallback={this.handleDestinationChange} value popupId='country-list-popup' onToggleButtonClick={this.hadleToggleButtonClick} handlePopupItems />
        </div>
        <div className='hero-search__field'>
          {
            kind === 10
              ? (<Fragment>
                <i className='font-icons field-icon calendar-icon' />
                <Select
                  ref={this.selectRef}
                  onChange={(selectedOption) => this.handleMonthChange(selectedOption)}
                  value={departureMonth}
                  options={monthes}
                  styles={autosuggestStyles}
                  isSearchable={false}
                  valueKey='id'
                  openMenuOnFocus
                  isClearable
                  className='select-container'
                  classNamePrefix='select-container' />
              </Fragment>
              ) : (
                <TravelDatepicker withIcon className='hero-datepicker'
                  minDuration={1}
                  maxDuration={21}
                  id='datepicker'
                  range
                  dateFrom={dateFrom}
                  dateTo={dateTo}
                  updateDuration
                  datesInOneField
                  callback={this.handleDatesChange} />
              )
          }

        </div>
        <div className='hero-search__field'>
          <GuestPicker className='hero-guest-picker' onSelect={this.handleGuestsChange} hideError showIcon />
        </div>

        <button className='btn-red no-uppercase' onClick={this.handleSubmit} disabled={loading}>
          <FormattedMessage id='search' defaultMessage='Search' />
        </button>
      </div>
    )
  }
}

HeroSearch.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(HeroSearch)
